var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PatrolTermComponent',{attrs:{"typeName":"品質巡回 サイクル設定","type":1,"settionStrageName":"PatrolTermStorageItemName"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }